import React from 'react';
import PropTypes from 'prop-types';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {graphql} from 'react-apollo';
import ReactModal from 'react-modal';
import mutateProps from 'utils/mutateProps';

import {
  selectShowDealFinalized as selectShow,
} from 'flows/deal/status/reducer';

import {selectDealAllocations} from 'flows/deal/allocate/reducer';

import {
  finalizedMutation as mutation,
  cancelFinalized as cancelProp,
  finalizedProp as submitProp,
} from 'flows/deal/status';

import DealFinalizedConfirmation from './component';

export const DealFinalizedConfirmationContainer = ({deal, allocations, show, submitLoading, submit, cancel}) => (
  <ReactModal
    isOpen={show}
    contentLabel="What happens now?"
    shouldCloseOnOverlayClick
    className="ReactModal"
    ariaHideApp={false}
  >
    <DealFinalizedConfirmation
      sending={submitLoading}
      deal={deal}
      allocations={allocations}
      submit={submit}
      cancel={cancel}
    />
  </ReactModal>
);

DealFinalizedConfirmationContainer.propTypes = {
  deal: PropTypes.object.isRequired,
  show: PropTypes.bool.isRequired,
  allocations: PropTypes.object.isRequired,
  submitLoading: PropTypes.bool.isRequired,
  submit: PropTypes.func.isRequired,
  cancel: PropTypes.func.isRequired,
};

const mapMutation = props => ({
  submit: submitProp(props),
});

export const mapStore = store => ({
  show: selectShow(store),
  allocations: selectDealAllocations(store),
});

export default compose(
  graphql(mutation, {
    props: mapMutation,
  }),
  mutateProps({name: 'submit'}),
  connect(mapStore, {cancel: cancelProp}),
)(DealFinalizedConfirmationContainer);



// WEBPACK FOOTER //
// ./web/flows/deal/status_transitions/components/DealFinalizedConfirmation/index.js